import moment from 'moment';

import NextReservationSlot from '../models/next-reservation-slot.model';
import {readMinimalPerson} from './person.serializer';

/**
 * Read a reservation slot retrieved from the backend.
 * @param {Object} o
 * @returns {NextReservationSlot}
 */
function readNextReservationSlot(o) {
  const person = readMinimalPerson(o.person).makeImmutable();

  return new NextReservationSlot(
    o.id,
    moment(o.start_time),
    moment(o.end_time),
    o.location_id,
    o.location,
    o.service_id,
    o.service,
    person
  );
}

export {
  readNextReservationSlot
};



// WEBPACK FOOTER //
// ./src/app/common/serializers/next-reservation-slot.serializer.js